import { render, staticRenderFns } from "./autocomplete-av.vue?vue&type=template&id=5fe03b94&scoped=true"
import script from "./autocomplete-av.vue?vue&type=script&lang=js"
export * from "./autocomplete-av.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe03b94",
  null
  
)

export default component.exports